import { render, staticRenderFns } from "./LookupServices.vue?vue&type=template&id=a5c52fa0&scoped=true"
import script from "./LookupServices.vue?vue&type=script&lang=ts"
export * from "./LookupServices.vue?vue&type=script&lang=ts"
import style0 from "./LookupServices.vue?vue&type=style&index=0&id=a5c52fa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c52fa0",
  null
  
)

export default component.exports